module.exports = __webpack_public_path__ + "school/img/payment.15b7b56d.jpg";